import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CommonButton from "components/commonButton/CommonButton";

const BulkEmployeeUploadResultModal = ({ failedRows = [], handleClose }) => {
  const downloadFailedRecords = (rows) => {
    if (!rows?.length) return;

    const headers = ["Row", "Employee ID", "Email", "Status", "Error"];

    const csvRows = [
      headers.join(","),
      ...rows.map((item) =>
        [
          item.row ?? "",
          item.employeeId ?? "",
          item.email ?? "",
          item.status ?? "",
          `"${(item.message || "").replace(/"/g, '""')}"`,
        ].join(","),
      ),
    ];

    const blob = new Blob([csvRows.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "failed_employee_records.csv";

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <Box
      className="bulkEmployeeUploadResult"
      sx={{
        width: "900px",
        maxWidth: "95vw",
      }}
    >
      {/* Header */}
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          mb: 2,
        }}
      >
        Bulk Upload Result
      </Typography>

      {/* Description + Download */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            color: "#666",
            flex: 1,
          }}
        >
          Some employee records could not be uploaded. Please review the errors
          below, correct them in the Excel file, and upload again.
        </Typography>

        <CommonButton
          name="Download CSV"
          btnClass="btnSm btnYellow"
          onClick={() => downloadFailedRecords(failedRows)}
        />
      </Box>

      {/* Table */}
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: 400,
          border: "1px solid #e5e5e5",
        }}
      >
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Row</strong>
              </TableCell>

              <TableCell>
                <strong>Employee ID</strong>
              </TableCell>

              <TableCell>
                <strong>Email</strong>
              </TableCell>

              <TableCell>
                <strong>Status</strong>
              </TableCell>

              <TableCell>
                <strong>Error</strong>
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {failedRows.length > 0 ? (
              failedRows.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.row}</TableCell>

                  <TableCell>{item.employeeId || "-"}</TableCell>

                  <TableCell>{item.email || "-"}</TableCell>

                  <TableCell
                    sx={{
                      textTransform: "capitalize",
                    }}
                  >
                    {item.status || "-"}
                  </TableCell>

                  <TableCell
                    sx={{
                      color: "#d32f2f",
                    }}
                  >
                    {item.message || "-"}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No failed records found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Footer */}
      <Box
        sx={{
          mt: 3,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <CommonButton
          name="Close"
          btnClass="btnSm btnYellow"
          onClick={handleClose}
        />
      </Box>
    </Box>
  );
};

export default BulkEmployeeUploadResultModal;
